import './DotaPoster.css';
import { KZ_MONTHS } from '../data';

export default function DotaPoster({ tour, lang = 'ru', compact = false }) {
  const start = tour.startDate ? new Date(`${tour.startDate}T12:00:00+05:00`) : null;
  const end = tour.endDate ? new Date(`${tour.endDate}T12:00:00+05:00`) : null;
  const format = (date, options) => new Intl.DateTimeFormat('ru-RU', { timeZone: 'Asia/Almaty', ...options }).format(date);
  const month = start && (lang === 'kz'
    ? `${KZ_MONTHS[Number(format(start, { month: 'numeric' })) - 1]} ${format(start, { year: 'numeric' })}`
    : format(start, { month: 'long', year: 'numeric' }));
  return (
    <div className={`dota-poster${compact ? ' dota-poster--compact' : ''}`} role="img" aria-label={`${tour.title} · ${tour[`date_${lang}`] || tour.date_ru}`}>
      <div className="dota-poster__eyebrow">NOVA · OPEN TOURNAMENT</div>
      <strong className="dota-poster__title">DOTA <b>2</b></strong>
      <div className="dota-poster__date">{start && end ? `${format(start, { day: 'numeric' })}—${format(end, { day: 'numeric' })}` : '5 × 5'}</div>
      <div className="dota-poster__month">{month || 'LAN'}</div>
      <div className="dota-poster__footer">5 × 5 <i /> LAN <i /> {lang === 'kz' ? 'ПЕТРОПАВЛ' : 'ПЕТРОПАВЛОВСК'}</div>
    </div>
  );
}
